// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3d57011f","239":"d7ebdd5d","453":"90149573","455":"d3143c59","472":"76086caa"}[chunkId] + ".chunk.js";
};